import { forwardRef, JSX } from 'react';
import { Box, BoxProps } from '../Box';

export const Card = forwardRef(
  (props: BoxProps, ref): JSX.Element => (
    <Box
      ref={ref}
      p={3}
      bg="bg-0"
      {...props}
      sx={{
        borderRadius: 10,
        borderColor: 'gray10',
        borderStyle: 'solid',
        borderWidth: 1,
        ...(props.sx || {}),
      }}
    />
  ),
);

Card.displayName = 'Card';

export default Card;
